"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAppHybInitializer = void 0;
/* eslint-disable complexity */
const translations_1 = require("../../translations");
const tracker_1 = require("../../tracker");
const uiInformation_1 = require("../../uiInformation");
const featureFlag_1 = require("../../featureFlag");
// types
const initializer_1 = require("../../initializer");
const libraries_1 = require("../../libraries");
const mobileConnector_1 = require("../../mobileConnector");
const initializer_new_1 = require("../../initializer-new");
const subAppHybInitializer = async ({ API, libraries = [], trackerConfig, featureFlagConfig, translationsConfig, }) => {
    if (trackerConfig) {
        await (0, tracker_1.initAllTrackers)(trackerConfig, API, initializer_1.GenericUSDManager, initializer_1.Authenticator);
        (0, tracker_1.addCommonInfoToTealiumTracker)(trackerConfig);
    }
    const promises = [];
    if (await (0, mobileConnector_1.initMobileCommunicatorWithoutSession)()) {
        (0, initializer_new_1.initializeCommunicationWebView)();
    }
    try {
        const initPromises = [];
        if (translationsConfig) {
            initPromises.push((0, translations_1.initConfigWebAndOwnTranslations)(API, translationsConfig));
        }
        if (featureFlagConfig) {
            initPromises.push((0, featureFlag_1.initFeatureFlag)(featureFlagConfig, API));
        }
        await Promise.allSettled(initPromises);
    }
    catch {
        console.error('Can`t initiate feature flag or translations. Check network');
    }
    promises.push((0, uiInformation_1.initDeviceUUID)());
    promises.push((0, libraries_1.initLibraries)(libraries));
    try {
        await Promise.all(promises);
    }
    catch (error) {
        console.error(error);
        console.error('Can`t initiate feature flag or translations. Check network');
    }
};
exports.subAppHybInitializer = subAppHybInitializer;
//# sourceMappingURL=initializer.js.map